import { jsxs as C, jsx as u } from "react/jsx-runtime";
import { c as G } from "./clsx-OuTLNxxd.js";
import * as H from "react";
import J, { useContext as j, useRef as D, useState as S, useMemo as $, useEffect as b, cloneElement as Q } from "react";
import { M as N, d as g, a as W, P as X, N as Y, b as k, s as z } from "./popup-Rk9B6_Q2.js";
import { useMap as v } from "./components/elements/map/map.hook.js";
function L(t, e) {
  if (!t)
    throw new Error(e);
}
let p = 0;
function ee(t, e, n) {
  if (t.style && t.style._loaded) {
    const o = { ...n };
    return delete o.id, delete o.children, t.addSource(e, o), t.getSource(e);
  }
  return null;
}
function te(t, e, n) {
  var r, a, c;
  L(e.id === n.id, "source id changed"), L(e.type === n.type, "source type changed");
  let o = "", l = 0;
  for (const f in e)
    f !== "children" && f !== "id" && !g(n[f], e[f]) && (o = f, l++);
  if (!l)
    return;
  const i = e.type;
  if (i === "geojson")
    t.setData(e.data);
  else if (i === "image")
    t.updateImage({
      url: e.url,
      coordinates: e.coordinates
    });
  else
    switch (o) {
      case "coordinates":
        (r = t.setCoordinates) == null || r.call(t, e.coordinates);
        break;
      case "url":
        (a = t.setUrl) == null || a.call(t, e.url);
        break;
      case "tiles":
        (c = t.setTiles) == null || c.call(t, e.tiles);
        break;
      default:
        console.warn(`Unable to update <Source> prop: ${o}`);
    }
}
function oe(t) {
  const e = j(N).map.getMap(), n = D(t), [, o] = S(0), l = $(() => t.id || `jsx-source-${p++}`, []);
  b(() => {
    if (e) {
      const r = () => setTimeout(() => o((a) => a + 1), 0);
      return e.on("styledata", r), r(), () => {
        var a;
        if (e.off("styledata", r), e.style && e.style._loaded && e.getSource(l)) {
          const c = (a = e.getStyle()) == null ? void 0 : a.layers;
          if (c)
            for (const f of c)
              f.source === l && e.removeLayer(f.id);
          e.removeSource(l);
        }
      };
    }
  }, [e]);
  let i = e && e.style && e.getSource(l);
  return i ? te(i, t, n.current) : i = ee(e, l, t), n.current = t, i && H.Children.map(t.children, (r) => r && Q(r, {
    source: l
  })) || null;
}
function ne(t, e, n, o) {
  if (L(n.id === o.id, "layer id changed"), L(n.type === o.type, "layer type changed"), n.type === "custom" || o.type === "custom")
    return;
  const { layout: l = {}, paint: i = {}, filter: r, minzoom: a, maxzoom: c, beforeId: f } = n;
  if (f !== o.beforeId && t.moveLayer(e, f), l !== o.layout) {
    const y = o.layout || {};
    for (const s in l)
      g(l[s], y[s]) || t.setLayoutProperty(e, s, l[s]);
    for (const s in y)
      l.hasOwnProperty(s) || t.setLayoutProperty(e, s, void 0);
  }
  if (i !== o.paint) {
    const y = o.paint || {};
    for (const s in i)
      g(i[s], y[s]) || t.setPaintProperty(e, s, i[s]);
    for (const s in y)
      i.hasOwnProperty(s) || t.setPaintProperty(e, s, void 0);
  }
  g(r, o.filter) || t.setFilter(e, r), (a !== o.minzoom || c !== o.maxzoom) && t.setLayerZoomRange(e, a, c);
}
function ae(t, e, n) {
  if (t.style && t.style._loaded && (!("source" in n) || t.getSource(n.source))) {
    const o = { ...n, id: e };
    delete o.beforeId, t.addLayer(o, n.beforeId);
  }
}
let le = 0;
function I(t) {
  const e = j(N).map.getMap(), n = D(t), [, o] = S(0), l = $(() => t.id || `jsx-layer-${le++}`, []);
  if (b(() => {
    if (e) {
      const r = () => o((a) => a + 1);
      return e.on("styledata", r), r(), () => {
        e.off("styledata", r), e.style && e.style._loaded && e.getLayer(l) && e.removeLayer(l);
      };
    }
  }, [e]), e && e.style && e.getLayer(l))
    try {
      ne(e, l, t, n.current);
    } catch (r) {
      console.warn(r);
    }
  else
    ae(e, l, t);
  return n.current = t, null;
}
const O = "#f7a800";
function re({
  longitude: t,
  latitude: e,
  radiusInMeters: n,
  color: o = "primary",
  opacity: l = 0.2,
  strokeWidth: i = 2
}) {
  const [r, a] = S(O);
  b(() => {
    const y = getComputedStyle(document.documentElement);
    a(y.getPropertyValue(`--color-${o}`) || O);
  }, [o]);
  const c = Array.from({ length: 64 }, (y, s) => {
    const m = s / 64 * 2 * Math.PI, M = e + n / _ * Math.cos(m);
    return [t + n / (_ * Math.cos(e * Math.PI / 180)) * Math.sin(m), M];
  });
  return c.push(c[0]), /* @__PURE__ */ C(oe, { type: "geojson", data: {
    type: "Feature",
    geometry: {
      type: "Polygon",
      coordinates: [c]
    },
    properties: {}
  }, children: [
    /* @__PURE__ */ u(
      I,
      {
        type: "fill",
        paint: {
          "fill-color": r,
          "fill-opacity": l
        }
      }
    ),
    /* @__PURE__ */ u(
      I,
      {
        type: "line",
        paint: {
          "line-color": r,
          "line-width": i
        }
      }
    )
  ] });
}
const _ = 111320, ie = J.forwardRef(
  ({
    initialViewState: t = {
      longitude: 2.3522,
      latitude: 48.8566,
      zoom: 13
    },
    bounds: e,
    circleLayer: n,
    markers: o,
    singleMarker: l,
    popup: i,
    mapStyle: r,
    padding: a,
    className: c,
    onMoveEnd: f,
    onDragEnd: y,
    onResize: s,
    debounceEventsTime: m = 300,
    positionNavControl: M = "top-left",
    maxZoom: x = 19,
    minZoom: U = 0,
    randomPosition: B = !1,
    id: P = "1",
    centerMarker: h
  }, A) => {
    var w, R;
    const { mapRef: F, singleMarker: d, debouncedOnMoveEnd: K, handleDragEnd: T, debouncedOnResize: V, handleMapLoad: q } = v({
      initialSingleMarker: l,
      randomPosition: B,
      id: P,
      onMoveEnd: f,
      onDragEnd: y,
      onResize: s,
      debounceEventsTime: m,
      ref: A
    });
    return /* @__PURE__ */ C("div", { className: G(z["map-container"], c), children: [
      /* @__PURE__ */ C(
        W,
        {
          ref: F,
          initialViewState: {
            ...t,
            bounds: e,
            fitBoundsOptions: {
              padding: {
                top: (a == null ? void 0 : a.top) ?? 10,
                bottom: (a == null ? void 0 : a.bottom) ?? 10,
                left: (a == null ? void 0 : a.left) ?? 10,
                right: (a == null ? void 0 : a.right) ?? 10
              }
            }
          },
          mapStyle: r,
          dragRotate: !1,
          style: { width: "100%", height: "100%" },
          onMoveEnd: K,
          onResize: V,
          minZoom: U,
          maxZoom: x,
          onLoad: q,
          children: [
            n && /* @__PURE__ */ u(re, { ...n }),
            i && /* @__PURE__ */ u(X, { ...i }),
            /* @__PURE__ */ u(Y, { showCompass: !1, position: M }),
            o && o.map((E, Z) => /* @__PURE__ */ u(k, { ...E, children: E.content }, Z)),
            d && /* @__PURE__ */ u(
              k,
              {
                longitude: d.longitude,
                latitude: d.latitude,
                draggable: d.draggable,
                onDragEnd: T,
                children: d.content
              }
            )
          ]
        }
      ),
      h && /* @__PURE__ */ u(
        "div",
        {
          className: z["center-marker"],
          style: { transform: `translate(${((w = h.offset) == null ? void 0 : w.x) ?? 0}px, ${((R = h.offset) == null ? void 0 : R.y) ?? 0}px)` },
          children: h.content
        }
      )
    ] });
  }
);
ie.displayName = "MapBox";
export {
  re as C,
  ie as M,
  _ as O
};
